import { NgModule }                          from '@angular/core';
import { CommonModule }                      from '@angular/common';
import { MatDialogModule }                   from '@angular/material/dialog';
import { ComponentTranslationLoaderService } from '@cs/common/culture';
import { TranslateModule }                   from '@ngx-translate/core';
import { CsCommonPipesModule }               from '@cs/common';
import { MaintenanceModalComponent }         from './maintenance-modal.component';

const COMPONENTS = [MaintenanceModalComponent];

@NgModule({
											imports        : [
												CommonModule,
												MatDialogModule,
												TranslateModule,
												CsCommonPipesModule
											],
											exports        : [...COMPONENTS],
											declarations   : [...COMPONENTS],
											entryComponents: [...COMPONENTS]
										})
export class MaintenanceModalModule {

	constructor(loader: ComponentTranslationLoaderService) {
		loader.registerComponentModule('maintenance-modal');
	}
}
